import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AutoComplete, Form, Input, Select, Tabs } from 'antd';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import Others from 'component/create_user_component/create_singleUser/others';
import TabPane from 'antd/es/tabs/TabPane';
import Organization from 'component/create_user_component/create_singleUser/organization';
import Address from 'component/create_user_component/create_singleUser/address';
import UserFormCheckbox from 'component/form_component/checkBox';
import {
  FormHeader,
  FormItem,
  FormSubmitButtonConatainer,
  ModalFormContainer,
  RowWrapper,
} from 'component/form_component/style';
import TransferDataComponent from 'component/form_component/transferDataBox';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { getGroupsExceptUser, getGroupsOfUser } from 'redux/slices/usersGroupSlice';
import { editUserData, getAttributes, getLockOrDisable, getUpnSuggestions } from 'redux/slices/userSlice';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { useRefreshUserTab } from 'component/table_component/users_data/refreshUserData';
import { getChildOuDropdown, getDomainContainers } from 'redux/slices/getChildOu';
import { debounce } from 'lodash';
import { InputPatternRuleAD } from 'utils/input_pattern';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { UserStatusBottomWrap, UserStatusContent, UserStatusContentWrap, UserStatusWrap } from '../viewUser/style';

export default function EditUser({ singleUserData, handleCancel, ...record }) {
  const dispatch = useDispatch();
  const [formTab1] = Form.useForm();
  const [formTab2] = Form.useForm();
  const [formTab3] = Form.useForm();
  const [formTab4] = Form.useForm();
  const [attributeForm] = Form.useForm();
  const refreshUserTab = useRefreshUserTab();
  const [activeTab, setActiveTab] = useState('1');
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lockDisable, setLockDisable] = useState('');
  const [removedGroups, setRemovedGroups] = useState([]);
  const [assignedGroups, setAssignedGroups] = useState([]);
  const selectedNode = useSelector((state) => state.selectedNode);
  const { upnSuggestions } = useSelector((state) => state.getUsers);
  const adminOuName = useSelector((state) => state.ouTreeData.data);
  const { childOuDropdown, domainContainers } = useSelector((state) => state.getChildOuData);
  const { groupsOfUser, groupsExceptUser } = useSelector((state) => state.usersGroupSlice);

  let indexCounter = 1; // Initialize a counter
  let mergedArray = [];
  // Merge arrays and set groupAvailability property with sequential keys

  mergedArray = [
    ...groupsOfUser.map((group) => ({
      title: group.groupName,
      dn: group.distinguishedName,
      groupAvailability: true,
      key: String(indexCounter++),
      disabled: group.primaryGroup,
    })),
    ...groupsExceptUser.map((group) => ({
      title: group.groupName,
      dn: group.distinguishedName,
      groupAvailability: false,
      key: String(indexCounter++),
    })),
  ];

  const keysWithTrueGroupAvailability =
    mergedArray && mergedArray.filter((item) => item.groupAvailability).map((item) => item.key);
  const handleTransferChange = (nextTargetKeys, direction, moveKeys) => {
    setAssignedGroups(nextTargetKeys);

    setRemovedGroups(moveKeys);
  };

  useEffect(() => {
    dispatch(getUpnSuggestions(selectedNode.domainName ?? localStorage.getItem('domain')));
  }, []);

  const handleChange = debounce((value) => {
    setInputValue(value);
    if (value.includes('@')) {
      setOptions(upnSuggestions.map((option) => ({ value: option })));
    } else {
      setOptions([]);
    }
    const upn = formTab1.getFieldValue('userPrincipalName');
    formTab1.setFieldsValue({
      samAccountName: upn && upn.split('@')[0],
    });
  }, 300);

  const handleSelect = (value) => {
    const atIndex = inputValue.lastIndexOf('@');
    const newValue = inputValue.slice(0, atIndex + 1) + value;
    formTab1.setFieldsValue({
      userPrincipalName: newValue,
    });
  };

  useEffect(() => {
    let initialOuName = '';
    let fqdn = selectedNode.domainName ?? localStorage.getItem('domain');
    if (localStorage.getItem('role') === 'ouadmin') {
      initialOuName = adminOuName.dnName;
    } else {
      initialOuName =
        selectedNode.selectedNode && selectedNode.domainDn ? selectedNode.domainDn : localStorage.getItem('domainDn');
    }
    dispatch(
      getChildOuDropdown({
        fqdn: fqdn,
        ouName: initialOuName,
      })
    );
    dispatch(getDomainContainers(fqdn));
    dispatch(getAttributes(selectedNode.currentdomainId));
  }, [selectedNode]);

  useEffect(() => {
    formTab1.setFieldsValue({
      fqdn: selectedNode.domainName,
    });
  }, [selectedNode, formTab1]);

  useEffect(() => {
    let initialOuName = '';
    if (localStorage.getItem('role') === 'ouadmin') {
      initialOuName = adminOuName.dnName;
    } else {
      initialOuName =
        selectedNode.selectedNode && selectedNode.domainDn ? selectedNode.domainDn : localStorage.getItem('domainDn');
    }
    dispatch(getGroupsOfUser({ fqdn: selectedNode.domainName, userName: record.dn }));
    dispatch(
      getGroupsExceptUser({
        fqdn: selectedNode.domainName,
        userName: record.dn,
        ouName: initialOuName,
      })
    );
  }, []);

  const handleStatus = async () => {
    let typeNumber;
    if (!singleUserData.isEnabled && singleUserData.isLock) {
      typeNumber = 3;
    } else if (singleUserData.isLock) {
      typeNumber = 2;
    } else if (!singleUserData.isEnabled) {
      typeNumber = 1;
    }
    const values = {
      user: record.dn,
      fqdn: selectedNode.domainName,
      type: typeNumber,
    };
    try {
      setLoading(true);
      const response = await dispatch(getLockOrDisable(values));
      if (response?.payload?.status === 200) {
        setLockDisable(response.payload.data);
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      return error;
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async () => {
    let Account = formTab1.getFieldsValue();
    const Address = formTab2.getFieldsValue();
    const Organization = formTab3.getFieldsValue();
    const others = formTab4.getFieldsValue();
    const attributefields = attributeForm.getFieldsValue();
    let inputValue = Account.samAccountName;
    if (inputValue.match(InputPatternRuleAD.pattern)) {
      const result = await Swal.fire({
        icon: 'info',
        html: `The SAM AccountName ${inputValue} ${InputPatternRuleAD.message}`,
        showConfirmButton: true,
        confirmButtonColor: 'var(--bg-button-default-color)',
        showCancelButton: true,
        cancelButtonColor: 'green',
        width: '500px',
        heightAuto: false,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        customClass: {
          icon: 'custom-swal-icon',
          title: 'custom-swal-title',
        },
      });
      if (result.isConfirmed) {
        inputValue = inputValue.replace(InputPatternRuleAD.pattern, '_');
        formTab1.setFieldsValue({
          samAccountName: inputValue,
        });
        Account = formTab1.getFieldsValue();
      } else {
        return;
      }
    }
    Account.fqdn = selectedNode.domainName;
    const dn = record.dn;
    const addGroupNames = [];
    assignedGroups.forEach((item) => {
      if (!removedGroups.includes(item)) {
        addGroupNames.push(item.dn);
      }
    });
    const removeGroupNames = [];
    removedGroups.forEach((item) => {
      if (!assignedGroups.includes(item)) {
        removeGroupNames.push(item.dn);
      }
    });
    const customAttributes = [attributefields];
    const values = {
      dn,
      updateUser: [
        {
          ...Account,
          ...Address,
          ...Organization,
          ...others,
        },
      ],
      addGroupNames,
      removeGroupNames,
      customAttributes,
    };
    try {
      setLoading(true);
      const sweetAlert = await dispatch(editUserData(values));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
      } else if (sweetAlert.payload && sweetAlert.payload.response.status === 400) {
        if (
          sweetAlert.payload.response.data === 'SamAccountName already exists.' ||
          sweetAlert.payload.response.data === 'UPN already exists.'
        ) {
          SweetSweetAlert({ sweetData: sweetAlert.payload.response.data, icon: 'warning', buttonColor: 'orange' });
        } else {
          SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
        }
      }
      handleCancel();
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    }
    await refreshUserTab();
  };
  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  return (
    <ModalFormContainer style={{ marginBottom: 0 }} className='af-modal-container af-updateuser-modal-container'>
      {loading && <ModalOpenLoader />}
      <UserStatusWrap className='af-updateuser-status-section-wrap'>
        <div className='af-updateuser-status-dummy'></div>
        <UserStatusContentWrap className='af-updateuser-status-content-wrap'>
          <UserStatusContent className='af-updateuser-status-content'>
            <h4 className='af-updateuser-status-header'>Status:</h4>
            <span className='af-updateuser-status' style={{ display: 'flex' }}>
              <p
                className='af-updateuser-status-lock'
                style={{ color: singleUserData.isLock ? 'darkred' : 'darkgreen' }}
              >
                {singleUserData.isLock ? `Locked ${lockDisable && '(' + lockDisable.lockedDateTime + ')'}` : 'Unlocked'}
              </p>
              &nbsp;<p className='af-updateuser-status-slash'>/</p>&nbsp;
              <p
                className='af-updateuser-status-disable'
                style={{ color: singleUserData.isEnabled ? 'darkgreen' : 'darkred' }}
              >
                {singleUserData.isEnabled
                  ? 'Enabled'
                  : `Disabled ${lockDisable && '(' + lockDisable.disableDateTime + ')'}`}
              </p>
            </span>
          </UserStatusContent>
          {!lockDisable && (singleUserData.isLock || !singleUserData.isEnabled) && (
            <div className='af-updateuser-status-datetime-wrap'>
              <Link
                className='af-updateuser-status-datetime'
                style={{ textDecoration: 'underline' }}
                onClick={handleStatus}
              >
                Get Time?
              </Link>
            </div>
          )}
          {/* <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <h4>Last Logon:</h4>
                <span>{singleUserData.lastLogon}</span>
              </div> */}
        </UserStatusContentWrap>
      </UserStatusWrap>
      <FormHeader className='af-form-header af-updateuser-form-header'>
        {singleUserData.displayName ? singleUserData.displayName : singleUserData.samAccountName}
      </FormHeader>
      <Form
        className='af-form af-updateuser-form'
        form={formTab1}
        layout='vertical'
        name='register'
        onFinish={onFinish}
        initialValues={{
          displayName: singleUserData.displayName,
          emailAddress: singleUserData.email,
          samAccountName: singleUserData.samAccountName,
          givenName: singleUserData.givenName,
          surname: singleUserData.surname,
          password: '',
          initials: singleUserData.initials,
          userPrincipalName: singleUserData.userPrincipalName,
          ou: /OU=|CN=/.test(singleUserData.ouDn) ? singleUserData.ouDn : null,
          fqdn: selectedNode.domainName,
        }}
        size='large'
      >
        <Tabs
          className='af-form-tab af-updateuser-form-tab'
          activeKey={activeTab}
          defaultActiveKey='1'
          onChange={handleTabChange}
          tabPosition='top'
          tabBarGutter={20}
        >
          <TabPane
            className='af-form-tab-tabpane af-updateuser-form-tab-tabpane af-updateuser-form-tab-tabpane_account'
            tab='Account'
            key='1'
            forceRender
          >
            <RowWrapper className='af-form-row-wraper af-updateuser-form-row-wraper af-updateuser-form-row-wraper-wrap1'>
              <FormItem
                className='af-form-item af-updateuser-form-item af-updateuser-form-item-givenname'
                key='givenName'
                name='givenName'
                label='First Name'
                style={{ flex: '40%' }}
              >
                <Input className='af-form-input af-updateuser-form-input af-updateuser-form-input_givenname' />
              </FormItem>
              <FormItem
                className='af-form-item af-updateuser-form-item af-updateuser-form-item-initials'
                key='initials'
                name='initials'
                label='Initial'
                style={{ flex: '15%' }}
              >
                <Input className='af-form-input af-updateuser-form-input af-updateuser-form-input_initials' />
              </FormItem>
              <FormItem
                className='af-form-item af-updateuser-form-item af-updateuser-form-item-surname'
                key='surname'
                name='surname'
                label='Last Name'
                style={{ flex: '40%' }}
              >
                <Input className='af-form-input af-updateuser-form-input af-updateuser-form-input_surname' />
              </FormItem>
            </RowWrapper>

            <RowWrapper className='af-form-row-wraper af-updateuser-form-row-wraper af-updateuser-form-row-wraper-wrap2'>
              <FormItem
                className='af-form-item af-updateuser-form-item af-updateuser-form-item-displayName'
                key='displayName'
                name='displayName'
                label='Display Name'
              >
                <Input className='af-form-input af-updateuser-form-input af-updateuser-form-input_displayName' />
              </FormItem>

              <FormItem
                key='emailAddress'
                name='emailAddress'
                label='E-mail'
                rules={[
                  {
                    type: 'email',
                    message: `Please Enter the E-mail`,
                  },
                ]}
                className='af-form-item af-updateuser-form-item af-updateuser-form-item-emailAddress'
              >
                <Input className='af-form-input af-updateuser-form-input af-updateuser-form-input_emailAddress' />
              </FormItem>
            </RowWrapper>
            <RowWrapper className=' af-form-row-wraper af-updateuser-form-row-wraper af-updateuser-form-row-wraper-wrap3'>
              <FormItem
                key='userPrincipalName'
                name='userPrincipalName'
                label='User Principal Name (UPN)'
                rules={[
                  {
                    type: 'email',
                    required: true,
                    message: `The input is not a valid UPN!`,
                  },
                ]}
                className='af-form-item af-updateuser-form-item af-updateuser-form-item-upn'
              >
                <AutoComplete
                  className='af-form-input af-updateuser-form-input af-updateuser-form-input_upn'
                  onChange={handleChange}
                  options={options}
                  onSelect={handleSelect}
                  defaultActiveFirstOption
                />
              </FormItem>
              <FormItem
                key='samAccountName'
                name='samAccountName'
                label='SAM Account Name'
                rules={[
                  {
                    required: true,
                    message: `Please Enter the SAM Account Name`,
                  },
                ]}
                className='af-form-item af-updateuser-form-item af-updateuser-form-item-samName'
              >
                <Input className='af-form-input af-updateuser-form-input af-updateuser-form-input_samName' />
              </FormItem>
            </RowWrapper>
            {selectedNode.typeOfData !== 'builtinDomain' && (
              <RowWrapper className='af-form-row-wraper af-updateuser-form-row-wraper af-updateuser-form-row-wraper-wrap4'>
                <FormItem
                  key='ou'
                  name='ou'
                  label='Ou'
                  className='oddFormItem af-form-item af-updateuser-form-item af-updateuser-form-item-ou'
                >
                  <Select
                    className='af-form-select af-updateuser-form-select af-updateuser-form-select_ou'
                    allowClear
                    showSearch
                    placeholder='Select a Ou'
                  >
                    {domainContainers
                      .filter(
                        (container) => typeof container === 'object' && container.distinguishedName.includes('CN=Users')
                      )
                      .map((container) => (
                        <Select.Option
                          className='af-form-select-option af-updateuser-form-select-option'
                          key={container.distinguishedName}
                          value={container.distinguishedName}
                        >
                          {container.name} (Container)
                        </Select.Option>
                      ))}
                    {localStorage.getItem('role') === 'ouadmin' && (
                      <Select.Option
                        className='af-form-select-option af-updateuser-form-select-option'
                        key={adminOuName.dnName}
                        value={adminOuName.dnName}
                      >
                        {adminOuName.name}
                      </Select.Option>
                    )}
                    {childOuDropdown.map((ou) => (
                      <Select.Option
                        className='af-form-select-option af-updateuser-form-select-option'
                        key={ou.dnName}
                        value={ou.dnName}
                      >
                        {ou.name}
                      </Select.Option>
                    ))}
                  </Select>
                </FormItem>
              </RowWrapper>
            )}

            <FormItem
              label='Assign Group'
              className='af-form-item af-updateuser-form-item af-updateuser-form-item-asign_group'
            >
              {mergedArray && keysWithTrueGroupAvailability && (
                <TransferDataComponent
                  className='af-updateuser-transferbox'
                  leftBoxData={mergedArray}
                  rightBoxData={keysWithTrueGroupAvailability}
                  onChange={handleTransferChange}
                  leftBoxTitle={'Available Group(s)'}
                  rightBoxTitle={'Assigned Group(s)'}
                />
              )}
            </FormItem>

            <RowWrapper className='af-form-row-wraper af-updateuser-form-row-wraper af-updateuser-form-row-wraper-wrap5'>
              <UserFormCheckbox
                className='af-updateuser-checkbox af-updateuser-checkbox_next_logon'
                label={'User must change password on next login'}
                value={'passwordAtNextLogon'}
                form={formTab1}
                checkboxrecord={singleUserData}
              />
              <UserFormCheckbox
                className='af-updateuser-checkbox af-updateuser-checkbox_cannot_change'
                label={'User cannot change password'}
                value={'userCannotChangePassword'}
                form={formTab1}
                checkboxrecord={singleUserData}
              />
            </RowWrapper>
            <RowWrapper className='af-form-row-wraper af-updateuser-form-row-wraper af-updateuser-form-row-wraper-wrap6'>
              <UserFormCheckbox
                className='af-updateuser-checkbox af-updateuser-checkbox_acc_disable'
                label={'Password never Expires'}
                value={'passwordNeverExpires'}
                form={formTab1}
                checkboxrecord={singleUserData}
              />
              <UserFormCheckbox
                className='af-updateuser-checkbox af-updateuser-checkbox_acc_disable'
                label={'Account is disabled'}
                value={'disable'}
                form={formTab1}
                checkboxrecord={singleUserData}
              />
            </RowWrapper>
          </TabPane>
          <TabPane
            tab='Address'
            key='2'
            forceRender
            className='af-form-tab-tabpane af-updateuser-form-tab-tabpane af-updateuser-form-tab-tabpane_address'
          >
            <Address formTab2={formTab2} singleUserData={singleUserData} className='af-updateuser-form-address' />
          </TabPane>
          <TabPane
            tab='Organization'
            key='3'
            forceRender
            className='af-form-tab-tabpane af-updateuser-form-tab-tabpane af-updateuser-form-tab-tabpane_organization'
          >
            <Organization
              className='af-updateuser-form-organization'
              formTab3={formTab3}
              singleUserData={singleUserData}
            />
          </TabPane>
          <TabPane
            tab='Others'
            key='4'
            forceRender
            className=' af-form-tab-tabpane af-updateuser-form-tab-tabpane af-updateuser-form-tab-tabpane_others'
          >
            <Others
              formTab4={formTab4}
              attributeForm={attributeForm}
              singleUserData={singleUserData}
              className='af-updateuser-form-others'
            />
          </TabPane>
        </Tabs>
        <FormSubmitButtonConatainer className='af-form-button-submit-wrapper af-updateuser-form-button-submit-wrapper'>
          <StyledButton
            type='primary'
            htmlType='submit'
            className='af-form-button af-updateuser-form-button_submit af-updateuser-form-button af-updateuser-form-button_submit'
          >
            Submit
          </StyledButton>
        </FormSubmitButtonConatainer>
      </Form>
      <UserStatusBottomWrap className='af-updateuser-status-bottom-wrap'>
        <UserStatusContent className='af-updateuser-status-created-wrap'>
          <h4 className='af-updateuser-status-status-created-head'>Created:</h4>
          <span className='af-updateuser-status-status-created'>{singleUserData.createdAt}</span>
        </UserStatusContent>
        <UserStatusContent className='af-updateuser-status-status-lastChange-wrap'>
          <h4 className='af-updateuser-status-status-lastChange-head'>Last Changed:</h4>
          <span className='af-updateuser-status-status-lastChange'>{singleUserData.lastChanges}</span>
        </UserStatusContent>
      </UserStatusBottomWrap>
    </ModalFormContainer>
  );
}
